export const investingObjectiveOptions = [
    "Maximizing gains",
    "Minimizing losses",
    "Both equally",
];
//# sourceMappingURL=investingObjective.js.map